import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import MaterialGraphQL from '@graphql/material.queries';
import { Material } from '@models/material.model';

interface UseMaterialsReturn {
  materials: Material[];
  loading: boolean;
  error: string | null;
  fetchMaterials: (taskId: string) => Promise<void>;
  setMaterials: (materials: Material[]) => void;
}

export const useMaterials = (): UseMaterialsReturn => {
  const [materials, setMaterials] = useState<Material[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMaterials = useCallback(async (taskId: string) => {
    if (!taskId) return;

    setLoading(true);
    setError(null);

    try {
      const data: any = await graphQlClient.request(
        MaterialGraphQL.queries.getMaterials,
        { taskId },
      );

      const fetchedMaterials = data?.getMaterials || [];
      setMaterials(fetchedMaterials);
    } catch (err: any) {
      setError(
        err?.response?.errors?.[0]?.message || 'Failed to fetch materials',
      );
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    materials,
    loading,
    error,
    fetchMaterials,
    setMaterials,
  };
};
